module.exports = __webpack_public_path__ + "img/something wrong.b54ef24b.svg";